module.exports = __webpack_public_path__ + "img/img_youtube.f859490d.png";